export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'usageQty',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_lable_usageQty') || '单耗',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: '请输入',
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 4,
        disabled: that.disabled,
      },
    },
  },
  {
    field: 'fabricPositionName',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title:
      that.$l('INDEX.table_label_production_order_fabric_position_name') ||
      '面料位置',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'fabricNo',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('INDEX.form_label_fabricNo') || '面料编号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'fabricDisplayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    title: that.$l('INDEX.form_label_fabricDisplayName') || '面料显示名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'fabricWidth',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_fabricWidth') || '面料门幅',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'fabricWidth',
    },
  },
  {
    field: 'fabricWeight',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('INDEX.form_label_fabricWeight') || '面料克重',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'fabricWeight',
    },
  },
  {
    field: 'moq',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_moq') || '起定量',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'moq',
    },
  },
  {
    field: 'scmName',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('INDEX.form_label_scm') || '工厂名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
